import { v4 as uuid } from 'uuid'

import logger from 'common/logger'

import Arbiter from 'wrapper/containers/Arbiter'

import ContentDiscovery from 'wrapper/lib/contentDiscovery'

import Paywall from 'wrapper/lib/hostMutations/Paywall'
import UTMParser from 'wrapper/lib/hostMutations/UTMParser'
import AdBlockDetector from 'wrapper/lib/hostMutations/AdBlockDetector'
import UpdateWindowUser from 'wrapper/lib/hostMutations/UpdateWindowUser'
import WindowEvents from 'wrapper/lib/hostMutations/WindowEvents'
import QueryStringParser from 'wrapper/lib/hostMutations/QueryStringParser'
import { getAccessToken, getRefreshToken } from 'wrapper/lib/hostMutations/tokens'

import MenuLinks from 'wrapper/lib/hostDecorators/MenuLinks'
import CustomForms from 'wrapper/lib/hostDecorators/CustomForms'
import SignalDecorator from 'wrapper/lib/hostDecorators/SignalDecorator'
import PlanOptionLinks from 'wrapper/lib/hostDecorators/PlanOptionLinks'
import HostEventListener from 'wrapper/lib/hostDecorators/HostEventListener'
import PopupsDecorator from 'wrapper/lib/hostDecorators/PopupsDecorator'

const generateData = (overrides) => {
    const UTM = UTMParser()
    const { params: queryString, url } = QueryStringParser()

    const content = ContentDiscovery({ url, ...overrides })
    const payWall = new Paywall({
        breakId: window?.Pico?.break_selector,
        articleWrapperId: window?.Pico?.article_wrapper_id || window?.article_wrapper_id,
        url: content.url,
    })

    const menuLinks = new MenuLinks(window)
    const customForms = new CustomForms(window)
    const signalDecorator = new SignalDecorator(window)
    const planOptionLinks = new PlanOptionLinks(window)
    const hostEventListener = new HostEventListener(window)
    const popupsDecorator = new PopupsDecorator(window)

    // eslint-disable-next-line max-len
    const accessToken = queryString?.pico_token || queryString?.pico_access_token || getAccessToken()
    const refreshToken = queryString?.pico_refresh_token || getRefreshToken()

    return {
        accessToken,
        refreshToken,
        channelId: uuid(),
        publisherId: window?.Pico?.publisher_id || document.querySelector('[data-pico-id]')?.getAttribute('data-pico-id'),
        queryString,
        content,
        UTM,
        events: {
            init: () => WindowEvents('PICO/INIT'),
            update: (userWindowObject, event = null) => {
                // eslint-disable-next-line no-param-reassign
                event = event ?? (window.Pico.user ? 'PICO/UPDATED' : 'PICO/LOADED')

                UpdateWindowUser(userWindowObject)
                WindowEvents(event)
            },
        },
        UpdateWindowUser,
        initializeDecorators: ({ planOptions, signalsPayload } = {}) => {
            signalDecorator.init(signalsPayload)
            planOptionLinks.init(planOptions)
            menuLinks.init()
            customForms.init()
            hostEventListener.init()
            popupsDecorator.init()
        },
        updateDecorators: ({ planOptions, signalsPayload } = {}) => {
            signalDecorator.valueUpdater(signalsPayload)
            planOptionLinks.updateValues(planOptions)
        },
        adBlockDetector: async () => {
            const adblocked = await AdBlockDetector.init()
            return adblocked
        },
        hideArticle: ({ style, text }) => payWall.hideArticle({ style, text }),
        releaseArticle: (action) => payWall.releaseArticle(action),

        lifecycleEvent: (name, data) => {
            try {
                const event = new CustomEvent(name, data)

                document.dispatchEvent(event)
            } catch (error) {
                logger.error(error.message, error)
            }
        },
    }
}

let zoidInstance = null
const upsertZoidInstance = (data = {}) => {
    if (!zoidInstance) {
        zoidInstance = Arbiter(generateData(data))
    } else {
        zoidInstance.updateProps(generateData(data))
    }
    return zoidInstance
}

window.Pico.handleNavigationEvent = (data) => { upsertZoidInstance(data) }

if (window?.Pico?.plugin_version || !window.pico) {
    upsertZoidInstance()
}

WindowEvents('PICO/READY')

if (module.hot) {
    module.hot.accept()
}
